import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Input } from '../../ui/input';

/**
 * Compact search field for the top navbar (desktop only).
 * Submits to /search?q=... — same page as the Search icon,
 * but exposes the input so users can start typing without an extra click.
 */
export default function NavSearchBar({ className = '' }) {
  const navigate = useNavigate();
  const [q, setQ] = useState('');

  const submit = (e) => {
    e.preventDefault();
    const trimmed = q.trim();
    if (trimmed.length < 2) {
      navigate('/search');
      return;
    }
    navigate(`/search?q=${encodeURIComponent(trimmed)}`);
  };

  return (
    <form
      onSubmit={submit}
      className={`hidden lg:flex relative w-56 xl:w-72 ${className}`}
      data-testid="nav-search-form"
      role="search"
    >
      <Search
        className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-white/60 pointer-events-none"
        aria-hidden="true"
      />
      <Input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search pets, people, posts…"
        className="pl-8 h-9 rounded-full bg-white/10 border-white/15 text-white placeholder:text-white/50 focus-visible:bg-white/20 focus-visible:ring-white/40"
        data-testid="nav-search-input"
        aria-label="Search the site"
      />
    </form>
  );
}
